module.exports = __webpack_public_path__ + "static/media/add-link.ce948c10.svg";